// extracted by mini-css-extract-plugin
export default {"socialButton":"SocialMediaButton_socialButton__5LNTK"};